var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLionSpeakProductCardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230.999,
    height: 44.499,
    viewBox: "0 0 230.999 44.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3656",
    "data-name": "Group 3656",
    transform: "translate(-516.001 -776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652",
    transform: "translate(-24 196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M48.764,35.039a5.858,5.858,0,0,1-6.2,5.33c-5.729-.133-7.594,1.732-8.66,4.13,0,0-.932-3.131-.4-5,0,0-8.66,5-15.521-5.662l2.065.333s-5.4-5.929-12.99-4.663a17.264,17.264,0,0,1,9.726-4.463,20.009,20.009,0,0,1-3.6-2.465,14.5,14.5,0,0,0-9.127-3.531,15.372,15.372,0,0,1,9.127-2.331S7.329,9.593,0,9.926c0,0,4.663-4.53,12.191-1.732s8.26.466,12.657.066A8.8,8.8,0,0,1,18.787,0s2.731,3.131,9.859,1.2,14.522-.066,16.721,5.2,2.664,5.329,2.664,5.329A6.743,6.743,0,0,1,53.56,8.06c4-.266,6,3,11.191.4,0,0-.233,4.28-3.231,5.579,0,0,1.449.749,4.147-1.249a6.434,6.434,0,0,1-4.247,5.7,1.715,1.715,0,0,1,.55,1.2c-.05.649-.7,2.1,2.548,3.547a13.519,13.519,0,0,1,6.1,5.346c.65,1.3-.4,2.648-1.049,4a11.328,11.328,0,0,1-2.3,3c-.6.6-.4,1.449-1.1,2.848s-2.148,3.447-3.947,3.947-3.148-1.9-5.4-1.4a5.488,5.488,0,0,1-5.946-4.3,3.13,3.13,0,0,1-2.114-1.632",
    transform: "translate(540 580)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M100.525,78.874a7.462,7.462,0,0,0-1.349,3.3c-.7,3.148-2.62,4.5-6.159,4.121s-6.061,1.179-6.651,2.574c0,0,.959-6.63,7.24-6.06,5.12.464,3.022-3.133,6.919-3.932",
    transform: "translate(488.155 532.651)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M79.748,71.417a2.656,2.656,0,0,0-2.306,1.77c-.859,1.824-1.019,3.11-4.291,2.52A6.087,6.087,0,0,0,66.5,78.282c-1.448,1.984-5.9,6.383-13.73-.375,0,0,5.686,2.949,9.922-1.073s5.524-5.47,9.386-4.88,3.433-3.165,7.67-.536",
    transform: "translate(508.322 537.695)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M61.547,60.171a3.061,3.061,0,0,0-3.057.965c-1.4,1.5-4.238-1.662-8.689,1.395s-6.222,6.758-12.6,3.056-8.045-4.076-9.654-3.808a18.907,18.907,0,0,1,11.531-1.395c6.222,1.342,8.313-4.022,12.979-4.4a13.428,13.428,0,0,1,7.67,1.5,8.056,8.056,0,0,0-5.739-.053,28.014,28.014,0,0,0-4.72,2.36s3.164-2.146,6.114-1.073,2.575-1.341,6.168,1.448",
    transform: "translate(523.466 546.42)",
    fill: "#5bae7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M126.008,35.425s1.8-4.452,6.888-1.809c3.51,1.821,5.013,2.5,7.015.958,0,0-3.434,3.964-6.458,1.759s-3.666-2.04-7.445-.908",
    transform: "translate(464.357 560.323)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M82,20.023s-2.735-1.207-4.666-6.356S71.3,3.933,62.772,5.783s-10.137,0-10.137,0,.146,4.787,9.735,4.988c10.217.214,9.788,2.092,12.362,4.666S79.184,20.318,82,20.023",
    transform: "translate(508.403 576.779)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M41.157,33.349c.713-1.46,1.111-3.05,1.864-4.5a16.088,16.088,0,0,1,1.042-1.9,16.945,16.945,0,0,1-5.648.283c.717,2.063,1.824,4.124,2.743,6.117",
    transform: "translate(516.94 563.822)",
    fill: "#f77c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M57.388,24.843a27.7,27.7,0,0,0,3.3,5.12c1.175-2.331,1.233-5.244,2.617-7.5a16.132,16.132,0,0,0-2.457.449c-1.565.409-2.926.743-4.133,1.007a3.635,3.635,0,0,1,.667.921",
    transform: "translate(505.95 566.514)",
    fill: "#5bae7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M77.514,22.288c1.291,1.2,2.139,3,3.234,4.424a7.27,7.27,0,0,1,5.218-.445,10.906,10.906,0,0,0-8.453-3.979",
    transform: "translate(493.468 566.62)",
    fill: "#f77c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M69.211,30.468c2.379-1.028,4.163-2.014,5.713-2.73-1.052-1.47-1.943-3.316-3.269-4.357-1.342,2.11-1.468,4.811-2.443,7.087",
    transform: "translate(498.452 565.964)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M35.924,34.194a63.517,63.517,0,0,1-2.813-6.33c-.719.936-1.317,1.95-1.981,2.925a14.447,14.447,0,0,0,4.794,3.405",
    transform: "translate(521.313 563.273)",
    fill: "#5bae7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M51.83,30.214c-.355-.649-.753-1.259-1.148-1.883-.179-.283-.278-1.231-.526-.616-.217.535-.743.906-1.015,1.429a22.457,22.457,0,0,0-1.108,2.589,21.037,21.037,0,0,1-1.172,2.712,12.52,12.52,0,0,0,7.258-.811,17.6,17.6,0,0,1-2.289-3.419",
    transform: "translate(511.87 563.484)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M16.629,22.432a7.9,7.9,0,0,0-4.115.1,13.78,13.78,0,0,1,5.132,2.728c-.315-.951-.633-1.9-1.017-2.824",
    transform: "translate(532.488 566.658)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M26.818,27.173c.1.094.194.193.292.291.618-.917,1.191-1.861,1.856-2.745a18.277,18.277,0,0,1-1.97-.749,13.289,13.289,0,0,0-1.481-.55c.472,1.237.859,2.5,1.3,3.754",
    transform: "translate(524.684 565.941)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M61.112,48.455s-8.528-12.792-17.86-7.482c-9.317,5.3-12.952,2.736-15.526,1.609s-7.16-.322-7.16-.322,2.413-.161,6.356,2.9,8.437,5.351,15.366,1.69c5.632-2.977,10.942-3.138,18.826,1.609",
    transform: "translate(527.655 556.179)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M107.212,39.362a7.178,7.178,0,0,1,3.755-.59s-3.808-3-5.256-3.111,1.5,3.7,1.5,3.7",
    transform: "translate(476.782 558.593)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M38.2,44.083l1.8,2.14,1.225-2.116a10.691,10.691,0,0,1-3.024-.024m-6.131-.3L34,42.584A8.689,8.689,0,0,0,31.01,42Zm3.457.949,1.28-.971A24.069,24.069,0,0,1,34,42.584Zm8.948,1.288,1.479-3.266A19.265,19.265,0,0,1,41.928,44Zm17.973-2.9.6,2.293,1.793-.058a25.648,25.648,0,0,0-2.393-2.235M51.118,40.238l3.454,3.07,2.3-3.248a9.274,9.274,0,0,0-5.755.178m7.792,3.409,2.993-.958a15.109,15.109,0,0,0-5.023-2.627ZM46.332,42.592l3.02,2.14,1.46-4.38a10.51,10.51,0,0,0-1.29.624,34.4,34.4,0,0,1-3.19,1.616",
    transform: "translate(521.385 556.176)",
    fill: "#f77c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M40.817,44.181l.823,1.161.531-1.162a10.779,10.779,0,0,1-1.354,0m9.721-.821.48-2.255c-.679.381-1.328.719-1.948,1.019ZM54.007,39.9l2.225,1.731,1.582-1.758a9.2,9.2,0,0,0-3.807.027M36.913,43.155l.458.814.38-.482c-.325-.128-.63-.26-.918-.392Zm9.049,1.729.443-1.635c-.545.193-1.063.353-1.556.482Zm15-2.389,1.795-.439a15.85,15.85,0,0,0-2.482-1.4ZM34.219,43l.7-.7a8.757,8.757,0,0,0-1.027-.2Zm30.692.742.167.732.535-.086c-.225-.215-.459-.432-.7-.646",
    transform: "translate(519.657 556.175)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M42.983,53.147l1.576-1.22L47,55.231l-1.068-.1-1.525-2.542-1.373,1.068Z",
    transform: "translate(514.198 548.828)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M54.176,55.613,55.6,53.325l2.9,2.135-.508.407L55.752,54.24l-1.169,1.881Z",
    transform: "translate(507.478 547.989)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M66.259,52.968l1.373-2.695,2.745,1.983-.458.254-2.136-1.322-1.168,2.237Z",
    transform: "translate(500.225 549.821)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M79.106,48.515l.966-3.2L83.224,47.4l-.915.3-1.881-1.424-.661,2.085Z",
    transform: "translate(492.513 552.799)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M92.461,46.3l1.322-1.881L95.1,47.167l-.508-.1-.915-1.525-.763,1.22Z",
    transform: "translate(484.495 553.333)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M101.747,49.891l2.8-.763.407,1.983-.509-.2-.2-1.118-1.271.406Z",
    transform: "translate(478.921 550.508)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M113.321,55.208l1.119-.1,1.016,1.322Z",
    transform: "translate(471.973 546.919)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M37.691,51.289,36.42,49.255l-1.321.509.457.457.559-.254,1.22,1.576Z",
    transform: "translate(518.931 550.432)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M79.063,17.027c-.1-.147-.192-.3-.288-.46a1.356,1.356,0,0,0-1.432,1.405c.187.171.375.338.561.493a.966.966,0,0,1,1.159-1.439m-4.938-5.311a1.367,1.367,0,1,0-1.876.464,1.367,1.367,0,0,0,1.876-.464m-1.672.124a.97.97,0,1,1,1.332-.329.971.971,0,0,1-1.332.329m7.224,6.048a.969.969,0,0,1-1.3.951c.205.153.413.292.622.421a1.361,1.361,0,0,0,.879-.627,1.342,1.342,0,0,0,.138-.33q-.167-.194-.34-.415m.954,1.07c-.018.034-.028.069-.048.1a2.168,2.168,0,0,1-.644.673,4.893,4.893,0,0,0,.526.173,2.637,2.637,0,0,0,.508-.611l.008-.016c-.111-.1-.228-.2-.351-.321M62.423,6.356A1.367,1.367,0,0,0,64.3,5.891a1.339,1.339,0,0,0,.151-.383c-.143.018-.291.042-.437.065a1.016,1.016,0,0,1-.054.114.97.97,0,0,1-1.331.329.945.945,0,0,1-.183-.146c-.147.031-.3.062-.439.091a1.361,1.361,0,0,0,.416.4m14.022,9.027a1.367,1.367,0,1,0-2.524-.9c.139.163.284.33.438.5a.967.967,0,1,1,.575.6c.152.152.3.3.448.452a1.363,1.363,0,0,0,1.063-.653M66.6,7.538a1.367,1.367,0,1,0,.464,1.876A1.367,1.367,0,0,0,66.6,7.538m.124,1.671A.97.97,0,1,1,66.4,7.878a.969.969,0,0,1,.329,1.332m11.6,6.565q-.108-.206-.214-.424a2.727,2.727,0,0,0-.311.09,2.588,2.588,0,0,0,.1-.545c-.172-.381-.342-.787-.506-1.223q-.192-.512-.414-1.015a2.762,2.762,0,0,0-.34-.247,2.627,2.627,0,0,0-1.253-.371,2.643,2.643,0,0,0-.356-2.66q-.159-.2-.327-.392c-.01,0-.02.011-.03.016a2.6,2.6,0,0,0-2.59-.486A2.655,2.655,0,0,0,71.6,6.732c.008-.063.02-.126.034-.189a10.188,10.188,0,0,0-2.461-.885c-.029,0-.059,0-.088.006,0-.009,0-.018,0-.027-.133-.028-.268-.053-.4-.077a.965.965,0,0,1-.006.2,2.633,2.633,0,0,0-1.2.767.93.93,0,0,1-.251-.1.967.967,0,0,1-.441-1.043c-.131,0-.263-.005-.4,0a1.377,1.377,0,0,0,.087.755,2.639,2.639,0,0,0-.881-.046,2.2,2.2,0,0,1-.04-.679c-.153.01-.3.018-.46.032a2.7,2.7,0,0,0,.035.62c-.022.052-.046.1-.073.155a2.62,2.62,0,0,0-1.2.828,2.012,2.012,0,0,0-.172-.128,2.634,2.634,0,0,0-2.237-.227,2.666,2.666,0,0,0-.024-.611l-.447.08A2.138,2.138,0,0,1,60.359,8a2.622,2.622,0,0,0-.536-.637,1.265,1.265,0,0,0,.163-.207,1.351,1.351,0,0,0,.181-.865l-.39.058a.962.962,0,0,1-.131.6.948.948,0,0,1-.14.177c-.016-.011-.032-.023-.049-.033A2.616,2.616,0,0,0,57.9,6.725c0-.058-.016-.116-.023-.172-.157.011-.309.021-.457.029a2.168,2.168,0,0,1-2.377,2.467,7.929,7.929,0,0,0,.87.476c0-.028-.007-.056-.009-.084a2.654,2.654,0,0,0,.859-.39,1.378,1.378,0,0,0,.078.853c.2.072.419.139.643.2a.972.972,0,1,1,.774.2q.317.073.657.135a1.351,1.351,0,0,0,.345-.38A1.362,1.362,0,0,0,57.612,8.08a2.633,2.633,0,0,0,.274-.9,2.178,2.178,0,0,1,2.08,3.3c-.023.039-.054.07-.08.107.277.035.561.068.86.094a2.292,2.292,0,0,1-.233-.275,2.644,2.644,0,0,0-.1-2.33,2.117,2.117,0,0,1,.185.322,2.646,2.646,0,0,0,.488-.592,2.706,2.706,0,0,0,.261-.589,2.179,2.179,0,0,1,2.107.077c.053.032.1.068.148.1a2.633,2.633,0,0,0-.3.823,1.287,1.287,0,0,0-.273-.221,1.367,1.367,0,1,0,.464,1.876c.008-.012.012-.026.019-.039a2.621,2.621,0,0,0,.5.717,2.12,2.12,0,0,1-.251.257c1.29.051,2.392.132,3.331.243a2.728,2.728,0,0,0,.31-.176,1.359,1.359,0,0,0-.031.211c.133.017.267.034.393.052a.956.956,0,0,1,.134-.46.97.97,0,0,1,1.743.832q.2.052.382.109a1.36,1.36,0,0,0-1.771-1.714,2.639,2.639,0,0,0,.274-.9,2.164,2.164,0,0,1,1.335.3A2.19,2.19,0,0,1,70.8,11.9c.145.059.283.12.412.183a2.643,2.643,0,0,0-.165-2.169,2.072,2.072,0,0,1,.186.322,2.591,2.591,0,0,0,.749-1.181,2.185,2.185,0,1,1,.786,4.128c.184.18.357.367.528.562-.016-.037-.03-.074-.047-.11A2.636,2.636,0,0,0,75.138,12.5a2.165,2.165,0,0,1,1.268.3,2.189,2.189,0,0,1,.758,2.977,2.637,2.637,0,0,0-.677.715,2.272,2.272,0,0,1-.438.221c.192.195.383.387.571.572a2.21,2.21,0,0,1,.2-.46,2.633,2.633,0,0,0,.678-.716,2.207,2.207,0,0,1,.835-.335m-15.182-6.1a.981.981,0,1,1,.124-.649c0,.035.008.07.014.106a.966.966,0,0,1-.138.543m4.624.163a2.191,2.191,0,1,1-.744-3.008,2.191,2.191,0,0,1,.744,3.008m2.51-1.06a.966.966,0,0,1-.14.176c-.017-.01-.032-.023-.05-.033a2.622,2.622,0,0,0-1.556-.365,2.564,2.564,0,0,0-.05-.371.954.954,0,0,1,.134-.41.97.97,0,1,1,1.661,1m1.045.63A2.17,2.17,0,0,1,71,9.829a2.614,2.614,0,0,0-.537-.637,1.224,1.224,0,0,0,.163-.207A1.366,1.366,0,0,0,68.3,7.547a2.022,2.022,0,0,1,.068.222A2.627,2.627,0,0,0,67.6,6.691l.019-.021c.064.052.135.1.191.157A2.19,2.19,0,0,1,71.328,9.41M56.43,7.581a1.361,1.361,0,0,0,.166-.973c-.141,0-.277,0-.407,0a.968.968,0,1,1-1.8-.157q-.215-.039-.4-.084A1.365,1.365,0,0,0,56.43,7.581m16.63.608a1.361,1.361,0,0,0,1.042.154c-.125-.123-.253-.243-.384-.36a.949.949,0,0,1-.883-.705q-.21-.149-.429-.289a1.363,1.363,0,0,0,.655,1.2M52.809,5.884c-.026.064-.05.129-.07.194A3.677,3.677,0,0,0,53.074,7a2.164,2.164,0,0,1,.137-.892,2.18,2.18,0,0,1-.4-.226",
    transform: "translate(508.341 576.775)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M49.373,61.892c2.508-1.695,3.254-1.9,6.1-1.491a4.429,4.429,0,0,0,3.489-.648c-1.141-.163-1.642.64-3.584-.065a4.788,4.788,0,0,0-.611-.173,9.335,9.335,0,0,0-5.734,1.632c-3.253,2.441-6.236,4.067-10.913,2.508a35.112,35.112,0,0,0-8.005-1.878,16.029,16.029,0,0,0-2.572.969,4.481,4.481,0,0,1,1.468-.015,22.632,22.632,0,0,1,8.363,1.738c5.83,2.372,9.49-.881,12-2.576m11.43-1.3a9.032,9.032,0,0,1-5.126.755c-3.321-.407-4.27-.135-7.117,2.305s-5.423,4-10.1,2.373a27.016,27.016,0,0,0-4.194-1.119c.851.457,1.818,1,2.931,1.645.026.016.05.028.076.042.879.173,1.895.392,2.881.652,2.353.62,3.976.047,6.875-1.607.84-.682,1.732-1.43,2.772-2.144,4.451-3.057,7.294.107,8.689-1.395a3.06,3.06,0,0,1,3.057-.965c-.271-.21-.516-.387-.745-.542m-12.446-.329c3.013-2.349,4.578-2.351,5.945-1.976a7.194,7.194,0,0,1,1.293-.319c-.926-.364-3.995-1.231-7.442,1.481-4.134,3.253-6.371,3.592-10.235,2.169-.66-.244-1.273-.45-1.841-.631a18.228,18.228,0,0,0-2.71.122c1.151.272,2.69.679,4.415,1.255,3.66,1.22,5.965,1.492,10.575-2.1",
    transform: "translate(523.466 545.455)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M80.232,71.358l1.849,1.717L83.5,70.7c-1.6-.592-2.317.074-3.272.654M68.791,75.942c1.028.288,3.174,1.1,3.174,1.1l-.283-3.685c-.835.644-1.753,1.5-2.89,2.586m-7.425,2.944L63.271,80.5l.786-1.7a8.9,8.9,0,0,1-2.692.085m6.487-2.052a7.49,7.49,0,0,1-3.18,1.819l3.631,2s0-2.951-.027-4.22l-.424.4m6.857-1.776.907-3.224a6.057,6.057,0,0,0-3.743,1.38Zm2.528-3.1a9.669,9.669,0,0,0-1.585-.12l3.327,3.479.854-3.731a4,4,0,0,1-2.6.372",
    transform: "translate(503.162 537.694)",
    fill: "#5bae7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M84.413,70.48a2.562,2.562,0,0,0-1.495.4l1.069.98.458-1.322Zm-16.664,7.74,1.7,1.16-.235-2.076a7.483,7.483,0,0,1-1.464.915m3.615-2.909,1.744.459-.554-1.551c-.371.328-.766.692-1.19,1.092m-6.441,4.323.307-.727c-.233.023-.463.036-.689.04Zm14.514-7.643,1.245,2,.169-2.077a4.223,4.223,0,0,1-1.415.076M76.26,73.534l.4-1.633a5.622,5.622,0,0,0-1.921.685Z",
    transform: "translate(501.256 537.693)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M68.422,94.146l.407-1.558,2.847,1.66-.915.034-1.627-.949-.271.983Z",
    transform: "translate(498.926 524.419)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M80.462,89.192l-.339-2.881,2.678.847-.2.508-1.864-.407L81,88.887Z",
    transform: "translate(491.902 528.187)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M88.958,81.713l-.441-2.27,1.932,1.39-.339.237-1.017-.542.305.982Z",
    transform: "translate(486.863 532.31)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M96.4,78.865l.542-2.135L99.184,78.9l-.644-.1-1.322-1.254L96.946,78.8Z",
    transform: "translate(482.128 533.939)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M106.749,77.506l.848-3.322,1.8,1.594-.271.508-1.288-1.119-.577,2.373Z",
    transform: "translate(475.918 535.467)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M135.154,24.761a1.351,1.351,0,0,0,.151-.8c-.052-.143-.161-.249-.572-.2a2.114,2.114,0,0,0-.384.088,2.243,2.243,0,0,0-1.164.913,5.81,5.81,0,0,1,1.968,0",
    transform: "translate(460.048 565.742)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M138.818,24.506a2.832,2.832,0,0,1,.869-.478c.066-.022.138-.035.207-.052a7.736,7.736,0,0,0-1.132-.228.469.469,0,0,1,.084.151,1.112,1.112,0,0,1-.029.607",
    transform: "translate(456.701 565.744)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M138.8,25.367c.641.117,1.283.288,1.927.451.007-.005.05-.038.128-.088a.7.7,0,0,0,.132-.22.76.76,0,0,0,.038-.5.524.524,0,0,0-.044-.092c-.044-.018-.085-.032-.13-.052-.156-.067-.315-.127-.477-.184a2.058,2.058,0,0,0-.6.1,2.7,2.7,0,0,0-.971.587",
    transform: "translate(456.676 565.184)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M126.951,25.878a.406.406,0,0,1,.157.223c.007.024.014.049.019.074a4.019,4.019,0,0,1,.6-1.047,4.683,4.683,0,0,0-1.089.73h0a.36.36,0,0,1,.311.022",
    transform: "translate(463.98 564.915)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M132.92,24.22a2.42,2.42,0,0,1,.9-.6,6.952,6.952,0,0,0-1.249.16.57.57,0,0,1,.329.343.541.541,0,0,1,.024.1",
    transform: "translate(460.42 565.823)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M128.145,25.992a5.023,5.023,0,0,1,1.387-.707c.09-.03.186-.054.281-.08.03-.034.065-.072.115-.126a.455.455,0,0,0,.122-.447c-.067-.2-.3-.359-.767-.212a1.967,1.967,0,0,0-.9,1.028,5.839,5.839,0,0,0-.233.544",
    transform: "translate(463.074 565.375)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M135.125,26.772l-.012-.033.055-.036a5.575,5.575,0,0,0-2.418-.022l-.032.026a3.731,3.731,0,0,0,1.634.79c.044,0,.088,0,.132,0a.781.781,0,0,0,.134-.011,1.206,1.206,0,0,0,.139-.036.491.491,0,0,0,.367-.673",
    transform: "translate(460.329 564.058)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M148.9,26.309a.447.447,0,0,1,.094.154.757.757,0,0,1-.088.554,4.948,4.948,0,0,0,1.984-.211,4.879,4.879,0,0,0,1.383-.731c.007-.032.01-.05.01-.05a4.761,4.761,0,0,1-3.383.283",
    transform: "translate(450.617 564.376)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M129.363,27.107a4.746,4.746,0,0,0-1.6.893,3.959,3.959,0,0,0,.464.187,2.169,2.169,0,0,0,1.018.111c.131-.056.264-.111.4-.159.179-.145.167-.334.1-.555a1.927,1.927,0,0,0-.276-.507c-.034.011-.071.019-.105.03",
    transform: "translate(463.307 563.745)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M144.282,27.067a12.552,12.552,0,0,0,1.624.308c.075-.129.176-.336.12-.472-.029-.082-.095-.162-.295-.218a1.382,1.382,0,0,0-.781.057,3.012,3.012,0,0,0-.669.325",
    transform: "translate(453.387 564.002)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M145.58,25.786c-.238-.073-.486-.162-.742-.263a1.023,1.023,0,0,1-.034.514,2.893,2.893,0,0,1,.4-.165,2.072,2.072,0,0,1,.38-.086",
    transform: "translate(453.074 564.678)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M125.985,28.055a1.453,1.453,0,0,0-.021-.528c-.055-.119-.063-.151-.212-.116a.819.819,0,0,0-.2.112c-.474.317-.516,1.093-.491,1.575a5.086,5.086,0,0,1,.927-1.044",
    transform: "translate(464.931 563.553)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M146.994,29.114c-.038-.132-.233-.263-.432-.339a2.311,2.311,0,0,0-.378-.113l-.167-.03.047-.06a11.677,11.677,0,0,1-1.3-.236c.7.93,1.554,1.366,1.959,1.217a.417.417,0,0,0,.235-.193.3.3,0,0,0,.04-.247",
    transform: "translate(453.1 562.99)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M138.888,27.652a.644.644,0,0,1-.283.521,6.222,6.222,0,0,1,1.043.179l-.094-.078c-.261-.228-.5-.459-.667-.622",
    transform: "translate(456.795 563.4)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M141.28,27.533l.05-.032c-.646-.157-1.285-.336-1.916-.469.153.153.44.437.759.716a5.634,5.634,0,0,0,.494.4c.121.044.243.088.366.138s.266.106.394.153a.194.194,0,0,0,.078-.151,1.007,1.007,0,0,0-.062-.373,2.512,2.512,0,0,0-.163-.381",
    transform: "translate(456.309 563.772)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M149.671,27.778a.845.845,0,0,1,.464.428.5.5,0,0,1-.057.411.617.617,0,0,1-.22.216,2.824,2.824,0,0,0,2.781-1.9,5,5,0,0,1-1.225.614,5.183,5.183,0,0,1-1.744.235",
    transform: "translate(450.152 563.834)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M123.729,30.453a3.312,3.312,0,0,1,.064-1.282,4.729,4.729,0,0,0-.651,2.69,5.856,5.856,0,0,1,.587-1.408",
    transform: "translate(466.079 562.488)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M144.969,30.028a7.842,7.842,0,0,0,.963.268,3.573,3.573,0,0,1-.909-.736.625.625,0,0,1-.055.468",
    transform: "translate(452.974 562.255)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M125.8,29.822a5.05,5.05,0,0,0-.849,1.064c.007.048.012.077.012.078h0l-.065.012-.069.121a.39.39,0,0,0,.065.015.889.889,0,0,0,.408-.042,1.505,1.505,0,0,0,.478-.275.548.548,0,0,0,.207-.644,1.049,1.049,0,0,0-.187-.33",
    transform: "translate(465.062 562.098)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M123.972,33.367a5.524,5.524,0,0,0-.415,1.146,8.815,8.815,0,0,1,1.17-1.221c-.041.017-.084.041-.124.054a1.018,1.018,0,0,1-.631.021",
    transform: "translate(465.828 560.015)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M133.074,27.832c.02.046.039.093.055.141a.778.778,0,0,1,.015.52,5.921,5.921,0,0,1,.813-.177,4.335,4.335,0,0,1-.883-.485",
    transform: "translate(460.115 563.292)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M128.108,30.242a.738.738,0,0,1-.06.624,7.518,7.518,0,0,1,.895-.548,3.219,3.219,0,0,1-.905-.241,1.165,1.165,0,0,1,.07.165",
    transform: "translate(463.138 561.945)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M128.246,42.071a10.774,10.774,0,0,1,5.846,1.149c2.5,1.5,3.148,1.349,3.048,2.3s-.55,2.248,2.248,3.6,5.5,3.6,5.146,3.847a12.288,12.288,0,0,1-3.747.45c-1.4,0-3.7-3.1-4.8-4.3s0-3.347-.5-3.647-3.148,1.649-5.6.7-2.948-3.2-1.649-4.1",
    transform: "translate(463.432 554.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M119.239,45.749a4.681,4.681,0,0,0,4,3.947c3.7.7,5.446,3.5,2.748,5.1s-7.694-3.048-9.942-8.144a9.259,9.259,0,0,1,3.2-.9",
    transform: "translate(470.34 552.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M125.606,60.823s-.15,3.048-2.748,3.747-5.5-1.049-6.895-2.1a19.45,19.45,0,0,0-5.046-2.6s2.4,2.248,4.6,4.447a6.965,6.965,0,0,0,6.795,2s-1,2.548,1.3,3.747,4.1-.749,7.844-.05c0,0,1.849-3.3-.9-4.8s-2.6-1.2-4.946-4.4",
    transform: "translate(473.416 544.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M128.19,79.275s-.528,2.1,2.218,3.148-5.016,1.749-6.547-1.7,2.957-2.948,4.329-1.449",
    transform: "translate(465.835 533.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M131.542,90.273s2.248,1.6,5.8-.45a6.465,6.465,0,0,1,6.629-.267c.8.833-1.3,4.064-3.165,4.5-.849.2-2.065-1.332-4.463-1.132s-4.7-1.1-4.8-2.648",
    transform: "translate(461.035 526.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M165.116,80.117a12.784,12.784,0,0,0,.832-2,2.429,2.429,0,0,1,1.332-1.732c.733-.3.766.866-.2,2.265s-2.064,2.065-1.964,1.466",
    transform: "translate(440.884 534.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M124.065,53.986a7.146,7.146,0,0,1-1.2-.239,3.95,3.95,0,0,0,1.416,2.042,7.677,7.677,0,0,0,1.082-.173,5.452,5.452,0,0,1-1.295-1.63m1.353,8.736a5.447,5.447,0,0,1-1.457.042c1.154,1.221,2.568,1.1,5.521,1.189a7.55,7.55,0,0,1,3.7.994,6.8,6.8,0,0,0,.661-.745c-1.666-1.17-3.886-.713-6.065-.9a6.09,6.09,0,0,1-2.365-.582m-4.357-18.011a21.53,21.53,0,0,1,5.206,1.425c.56-.165,1.057-.363,1.452-.507-1.854-1.047-6.116-1.74-7.048-1.882a2.49,2.49,0,0,0,.39.965M129.678,59.6c.245-.743.112-1.959-2.144-2.738a6.5,6.5,0,0,1-2.156-1.229,3.805,3.805,0,0,0-.179.785,18.328,18.328,0,0,0,2.135,1.044c1.835.778,1.947,1.672,1.769,2.236q.283-.041.575-.1m-6.17-3.783c-2.341-.9-4.523-3.551-5.358-4.657-.384-.241-.8-.481-1.22-.707a14.34,14.34,0,0,0,4.991,5.143,6.724,6.724,0,0,0,1.587.221m-.821-6.849c2.932,1.369,3.537,2.794,3.662,3.351a2.448,2.448,0,0,0,.8-.946c-.368-.981-1.612-2.288-4.608-3.154a5.147,5.147,0,0,1-4.092-4.565c-.283.048-.5.089-.706.138.247,1.589,1.545,3.588,4.949,5.176m9.743.9c-2.8-1.349-2.6-2.5-2.648-3.647s-.6-1.3-2.9-2.6a17.671,17.671,0,0,0-4.359-1.58,10.193,10.193,0,0,0-1.187.032,1.584,1.584,0,0,0-.5.568,23.088,23.088,0,0,1,7.6,2.63c2.1,1.3.4,3.3,3.5,4.946a16.827,16.827,0,0,1,4.168,3.072,9.507,9.507,0,0,0,1.154-.185,22.635,22.635,0,0,0-4.822-3.236m-9.8,7.02a4.838,4.838,0,0,0-.954-.317,5,5,0,0,0,2.052,4.975,9.016,9.016,0,0,0,1.093.072,4.335,4.335,0,0,1-2.191-4.73m-2.358-.383a1.681,1.681,0,0,0-.821.352,6.477,6.477,0,0,0,1.659,3.926,6.728,6.728,0,0,0,1.161.46,6.452,6.452,0,0,1-2-4.738m1.215-6.337a4.761,4.761,0,0,1,2.623,2.647,3.029,3.029,0,0,0,1.043.042c-.143-.685-.8-2.036-3.616-3.339a9.566,9.566,0,0,1-5.029-5.294l-.467.2a19.793,19.793,0,0,0,2.373,3.98,23.939,23.939,0,0,0,3.073,1.766m6.244,11.75c-.182.1-.362.186-.536.265a14.987,14.987,0,0,1,7.358.872,3.062,3.062,0,0,0,.266-.84,10.643,10.643,0,0,0-7.087-.3M128.65,46.6a3.045,3.045,0,0,0,.432,2.519c.06.065.124.138.191.214-.637-1-.233-1.795-.623-2.733m5.228,6.816c.228,0,.472-.006.723-.016a26.138,26.138,0,0,0-3.521-2.482,7.819,7.819,0,0,1-1.214-.893c1.2,1.407,2.891,3.391,4.012,3.391m-6.108-.8c.276.719,1.081,1.825,3.41,2.745,2.647,1.045,2.162,2.817,1.625,3.8a8.824,8.824,0,0,1,1.154.067c.642-1.425.03-3.481-2.379-4.462a6.192,6.192,0,0,1-3.269-3.108,4.293,4.293,0,0,1-.54.963m-.893.83a3.373,3.373,0,0,1-.9.4c.179.831.685,1.713,3.652,2.763,1.99.7,1.841,1.9,1.426,2.714.243-.042.5-.079.759-.108.536-1.068.06-2.515-2.186-3.305-2.1-.739-2.624-1.958-2.754-2.465",
    transform: "translate(470.34 554.766)",
    fill: "#c7c9cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3655",
    "data-name": "Group 3655",
    transform: "translate(37 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653",
    transform: "translate(562.677 783.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M4.632,113.59v17.864H15.092v1.4H3.2V113.59Z",
    transform: "translate(-3.199 -113.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M27.624,114.885a1.049,1.049,0,1,1-2.1,0,1.049,1.049,0,1,1,2.1,0M25.9,132.914h1.3V119.262H25.9Z",
    transform: "translate(-8.884 -113.371)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M35.89,127.939c0-4.321,2.973-7.074,6.664-7.074s6.662,2.753,6.662,7.074-2.973,6.964-6.662,6.964-6.664-2.642-6.664-6.964m12.052,0c0-3.523-2.416-5.807-5.388-5.807s-5.389,2.284-5.389,5.807a5.394,5.394,0,1,0,10.778,0",
    transform: "translate(-11.522 -115.167)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    "data-name": "Path 3037",
    d: "M62.627,121.112v2.422a5.178,5.178,0,0,1,4.673-2.67c3.5,0,5.919,2.229,5.919,6v7.844h-1.3v-7.817c0-3.083-1.831-4.735-4.672-4.707a4.651,4.651,0,0,0-4.592,4.955v7.569h-1.3v-13.6Z",
    transform: "translate(-18.006 -115.167)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    "data-name": "Path 3038",
    d: "M97.355,117.212c-1.354-2.257-3.531-2.587-5.628-2.615-2.177,0-5.628.826-5.628,3.908,0,2.449,2.548,3.028,5.681,3.633,3.584.716,7.3,1.377,7.3,5.533-.026,4.349-4.247,5.4-7.353,5.4-2.894,0-6.185-1.24-7.618-4.185l1.274-.66c1.142,2.339,4.062,3.5,6.344,3.5s5.921-.66,5.921-4.074c.026-2.89-3.053-3.523-6.106-4.129-3.4-.688-6.875-1.4-6.875-4.954-.081-4.074,4.008-5.34,7.06-5.34,2.655,0,4.964.44,6.8,3.275Z",
    transform: "translate(-23.8 -113.221)",
    fill: "#cf5819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M111.851,140.4V121.132h1.274v3.22a6.221,6.221,0,0,1,5.681-3.413c3.557.138,6.371,2.615,6.371,6.991,0,4.569-2.973,7.046-6.663,7.046a5.892,5.892,0,0,1-5.415-3.386V140.4Zm12.025-12.469c0-3.826-2.389-5.7-5.362-5.7-3.052,0-5.309,2.395-5.309,5.725a5.384,5.384,0,0,0,5.309,5.725c2.973,0,5.362-1.927,5.362-5.753",
    transform: "translate(-30.863 -115.186)",
    fill: "#cf5819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M136.565,127.92a6.72,6.72,0,0,1,6.664-7.019c3.689,0,6.981,2.34,6.477,7.652H137.893a5.233,5.233,0,0,0,5.336,5.037,6.066,6.066,0,0,0,4.725-2.065l.929.771a7.1,7.1,0,0,1-5.654,2.615c-3.69,0-6.664-2.67-6.664-6.992m11.973-.55c-.027-3.358-2.151-5.23-5.309-5.23a5.323,5.323,0,0,0-5.336,5.23Z",
    transform: "translate(-37.156 -115.177)",
    fill: "#cf5819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M174.642,121.141v13.6h-1.3v-2.89a6.085,6.085,0,0,1-5.362,3.11,7,7,0,0,1,0-13.983,5.909,5.909,0,0,1,5.362,3.137v-2.972Zm-12.025,6.8a5.369,5.369,0,0,0,5.362,5.7c7.3,0,7.3-11.367,0-11.367a5.345,5.345,0,0,0-5.362,5.669",
    transform: "translate(-43.458 -115.196)",
    fill: "#cf5819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M188.765,113.59v11.615l6.186-5.945h1.725v.055l-6.636,6.358,7.406,7.1v.083H195.8l-7.035-6.661v6.661h-1.274V113.59Z",
    transform: "translate(-50.122 -113.315)",
    fill: "#cf5819"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3654",
    "data-name": "Group 3654",
    transform: "translate(562.254 810.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M2.632,149.836v.325H4.308v4.89h.325v-4.89H6.146v-.325Z",
    transform: "translate(-2.633 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    "data-name": "Path 3044",
    d: "M13.141,155.051l-1.855-2.257h-.633v2.257h-.325v-5.215H11.44a2.9,2.9,0,0,1,.821.107,1.794,1.794,0,0,1,.6.3,1.223,1.223,0,0,1,.359.487,1.566,1.566,0,0,1,.111.642,1.17,1.17,0,0,1-.15.637,1.59,1.59,0,0,1-.388.449,1.852,1.852,0,0,1-.381.2,2.449,2.449,0,0,1-.713.137l1.881,2.265ZM11.7,152.469a1.741,1.741,0,0,0,.466-.064,1.206,1.206,0,0,0,.423-.209,1.116,1.116,0,0,0,.3-.347,1.051,1.051,0,0,0,.119-.483,1.564,1.564,0,0,0-.089-.508.884.884,0,0,0-.261-.372,1.331,1.331,0,0,0-.487-.239,2.683,2.683,0,0,0-.734-.086h-.787v2.308Z",
    transform: "translate(-4.591 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    "data-name": "Path 3045",
    d: "M21.576,154.951l-.658-1.547h-2.6l-.667,1.547H17.3l2.308-5.505,2.317,5.505Zm-.8-1.872-1.171-2.915-1.163,2.915Z",
    transform: "translate(-6.368 -149.429)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2760",
    "data-name": "Rectangle 2760",
    width: 0.325,
    height: 5.215,
    transform: "translate(18.021 0.308)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    "data-name": "Path 3046",
    d: "M31.1,149.423l3.864,4.993v-4.685h.316v5.625l-3.855-4.993v4.582H31.1Z",
    transform: "translate(-9.88 -149.423)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2761",
    "data-name": "Rectangle 2761",
    width: 0.325,
    height: 5.215,
    transform: "translate(28.262 0.308)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    "data-name": "Path 3047",
    d: "M44.837,149.423l3.864,4.993v-4.685h.316v5.625l-3.855-4.993v4.582h-.325Z",
    transform: "translate(-13.378 -149.423)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    d: "M56.472,155.121a2.735,2.735,0,0,1-1.082-.209,2.63,2.63,0,0,1-.859-.585,2.763,2.763,0,0,1-.56-.864,2.7,2.7,0,0,1-.2-1.043,2.76,2.76,0,0,1,.761-1.924,2.691,2.691,0,0,1,.859-.577,2.736,2.736,0,0,1,1.082-.209,2.665,2.665,0,0,1,1.1.227,2.868,2.868,0,0,1,.893.619l-.214.231a2.539,2.539,0,0,0-.8-.556,2.434,2.434,0,0,0-.979-.2,2.4,2.4,0,0,0-.958.189,2.357,2.357,0,0,0-.752.508,2.326,2.326,0,0,0-.5.757,2.415,2.415,0,0,0-.18.932,2.39,2.39,0,0,0,.18.923,2.322,2.322,0,0,0,.5.757,2.349,2.349,0,0,0,.752.509,2.4,2.4,0,0,0,.958.187h.1a2.259,2.259,0,0,0,.688-.107,2.172,2.172,0,0,0,.607-.3,1.683,1.683,0,0,0,.436-.449,1.013,1.013,0,0,0,.167-.564v-.734h-1.7v-.326H58.8v1.137a1.251,1.251,0,0,1-.15.56,1.715,1.715,0,0,1-.441.538,2.438,2.438,0,0,1-.726.406,2.849,2.849,0,0,1-1,.162Z",
    transform: "translate(-15.652 -149.496)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M73.688,154.951,73.03,153.4h-2.6l-.667,1.547h-.35l2.308-5.505,2.317,5.505Zm-.795-1.872-1.171-2.915-1.163,2.915Z",
    transform: "translate(-19.636 -149.429)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M81.552,150.161H80.039v4.89h-.325v-4.89H78.038v-.325h3.514Z",
    transform: "translate(-21.832 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M95.123,154.951l-.658-1.547h-2.6l-.667,1.547h-.35l2.308-5.505,2.317,5.505Zm-.795-1.872-1.171-2.915-1.163,2.915Z",
    transform: "translate(-25.093 -149.429)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M110.166,155.051h-.325v-2.624h-3.266v2.624h-.325v-5.215h.325V152.1h3.266v-2.265h.325Z",
    transform: "translate(-29.014 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2762",
    "data-name": "Rectangle 2762",
    width: 0.326,
    height: 5.215,
    transform: "translate(84.057 0.308)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M121.947,155.121a2.735,2.735,0,0,1-1.082-.209,2.649,2.649,0,0,1-.859-.585,2.75,2.75,0,0,1-.56-.864,2.718,2.718,0,0,1-.2-1.043,2.769,2.769,0,0,1,.2-1.055,2.643,2.643,0,0,1,2.5-1.655,2.664,2.664,0,0,1,1.1.227,2.88,2.88,0,0,1,.894.619l-.213.231a2.554,2.554,0,0,0-.8-.556,2.43,2.43,0,0,0-.978-.2,2.392,2.392,0,0,0-.958.189,2.357,2.357,0,0,0-.752.508,2.313,2.313,0,0,0-.5.757,2.415,2.415,0,0,0-.18.932,2.39,2.39,0,0,0,.18.923,2.31,2.31,0,0,0,.5.757,2.349,2.349,0,0,0,.752.509,2.392,2.392,0,0,0,.958.187h.1a2.264,2.264,0,0,0,.689-.107,2.158,2.158,0,0,0,.606-.3,1.7,1.7,0,0,0,.437-.449,1.019,1.019,0,0,0,.167-.564v-.734h-1.7v-.326h2.026v1.137a1.242,1.242,0,0,1-.15.56,1.705,1.705,0,0,1-.441.538,2.429,2.429,0,0,1-.726.406,2.841,2.841,0,0,1-1,.162Z",
    transform: "translate(-32.323 -149.496)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M133.7,155.051h-.325v-2.624H130.11v2.624h-.325v-5.215h.325V152.1h3.266v-2.265h.325Z",
    transform: "translate(-35.007 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M142.079,155.051h-3.223v-5.215h3.009v.324H139.18V152.1h2.215v.325H139.18v2.3h2.9Z",
    transform: "translate(-37.316 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M149.2,155.051l-1.855-2.257h-.633v2.257h-.325v-5.215H147.5a2.9,2.9,0,0,1,.821.107,1.794,1.794,0,0,1,.6.3,1.214,1.214,0,0,1,.359.487,1.566,1.566,0,0,1,.113.642,1.183,1.183,0,0,1-.15.637,1.583,1.583,0,0,1-.39.449,1.862,1.862,0,0,1-.38.2,2.454,2.454,0,0,1-.714.137l1.881,2.265Zm-1.436-2.582a1.735,1.735,0,0,0,.465-.064,1.2,1.2,0,0,0,.423-.209,1.126,1.126,0,0,0,.3-.347,1.069,1.069,0,0,0,.12-.483,1.626,1.626,0,0,0-.089-.508.893.893,0,0,0-.262-.372,1.333,1.333,0,0,0-.487-.239,2.7,2.7,0,0,0-.736-.086h-.786v2.308Z",
    transform: "translate(-39.235 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M163.382,155.051H160.21v-5.215h.317v4.89h2.855Z",
    transform: "translate(-42.754 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M170.911,155.051h-3.223v-5.215H170.7v.324h-2.684V152.1h2.215v.325h-2.215v2.3h2.9Z",
    transform: "translate(-44.657 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M174.707,149.836h.359l1.958,4.736,1.923-4.736h.369l-2.3,5.6Z",
    transform: "translate(-46.444 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    "data-name": "Path 3060",
    d: "M187.174,155.051h-3.223v-5.215h3.009v.324h-2.685V152.1h2.215v.325h-2.215v2.3h2.9Z",
    transform: "translate(-48.798 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    "data-name": "Path 3061",
    d: "M194.669,155.051H191.5v-5.215h.316v4.89h2.856Z",
    transform: "translate(-50.719 -149.528)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M198.826,156.385a.332.332,0,0,1,.089-.239.31.31,0,0,1,.236-.095.323.323,0,0,1,.332.333.307.307,0,0,1-.094.235.329.329,0,0,1-.239.09.308.308,0,0,1-.326-.325",
    transform: "translate(-52.586 -151.111)",
    fill: "#030404"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLionSpeakProductCardLogo);
export default __webpack_public_path__ + "static/media/lionSpeakProductCardLogo.8b1a8821.svg";
export { ForwardRef as ReactComponent };